// Define shared defaults outside the slices
export const defaultSurvey = {
    id: null,
    templateType: 'template',
    title: 'Untitled Survey',
    description: '',
    category: '',
    createdAt: null,
    updatedAt: null,
    status: 'draft',
    slug: null,
    showProgressbar: false,
    progressbarType: 'percent',
    singleQuestionPerPage: false,
    templateId: null,
    modifiedTemplate: false,
    startDate: null,
    endDate: null,
    surveyEndMessage: 'This survey has ended. We appreciate your time and support.',
    targetResponse: null,
    maxResponse: null,
    allowAnonymous: false,
    redirectUrl: null,
    messageAfterComplete: null,
    redirectTimeAfterMessage: 0,
    customCss: null,
    additionalSettings: null,
    pageWidth: '900px', //added new
    pagePaddingDesktop: '2rem',
    formContainerShowCard: false,
    formContainerCardShadow: false,
    formContainerPadding: '2rem',
    formContainerBackgroundColor: 'auto', // auto uses surface color
    formContainerBorderRadius: 'auto', // auto uses theme border radius
    headerPosition:"center",
    headingType:"h1",
    descriptionPosition: "center",
    descriptionColor:"",
};

export const defaultQuestions = [];
